import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useAsyncResource } from 'use-async-resource';
import { useGeoCoordinates } from '../../utils/groups-hooks';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { MapPosition } from '../../models/dashboard-models';

const apiKey = `${process.env.REACT_APP_GOOGLE_API_KEY}`;
const mapContainerStyle = {
    width: '100%',
    height: '100%',
};
const defaultZoomValue = 13;
const ZoomByTypeMap = { continent: 3, country: 7 } as {
    [index: string]: number;
};

export const GeoCodingMap = ({
    setPosition,
    defaultPosition,
}: {
    setPosition: (m: MapPosition) => void;
    defaultPosition?: MapPosition;
}) => {
    const [map, setMap] = useState({} as google.maps.Map);
    const defaultValue = defaultPosition ?? { center: { lat: 42.733883, lng: 25.48583 }, zoom: 7 };
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [address, setAddress] = useState('Bulgaria');
    const [zoom, setZoom] = React.useState(defaultValue.zoom);
    const [center, setCenter] = React.useState<google.maps.LatLngLiteral>(defaultValue.center!);
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: apiKey,
    });
    const options: google.maps.MapOptions = { streetViewControl: false };
    const [getCoordinates, updateAddress] = useAsyncResource(useGeoCoordinates, address, apiKey, i18n.language);
    const getLocation = () => {
        updateAddress(address, apiKey, i18n.language);
        const results = getCoordinates()?.results;
        if (address && results) {
            const [{ geometry, formatted_address, types }] = results;
            if (geometry) {
                const [zoomType] = types;
                setZoom(ZoomByTypeMap[zoomType] ?? defaultZoomValue);
                setCenter(geometry.location);
                setAddress(formatted_address);
            }
        }
    };
    const getLocationOnEnter = (e: React.FormEvent<HTMLFormElement | HTMLInputElement | HTMLTextAreaElement>) => {
        e.preventDefault();
        getLocation();
    };

    const updatePosition = () => {
        if (map && map.data) {
            const mapPosition: MapPosition = { center: map.getCenter()?.toJSON(), zoom: map.getZoom() };
            setPosition(mapPosition);
        }
    };

    return isLoaded ? (
        <>
            <Form onSubmit={getLocationOnEnter} className='d-flex w-100 mb-3'>
                <Form.Control
                    className='me-2'
                    type={'text'}
                    value={address}
                    onChange={({ target }) => setAddress(target.value)}
                    onSubmit={getLocationOnEnter}
                />
                <Button onClick={getLocation}>{t('search')}</Button>
            </Form>
            <GoogleMap
                onLoad={setMap}
                {...{ mapContainerStyle, zoom, center, options }}
                onZoomChanged={updatePosition}
                onCenterChanged={updatePosition}
            ></GoogleMap>
        </>
    ) : (
        <></>
    );
};
